<template>

  <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3 mt-3">
    <v-layout align-center  style="min-height: 48px;" v-if="box.title || box.pages[1]">
      <v-flex  class="text-xs-left" v-if="box.title">
        <div><h3 class="title pl-3">{{box.title}}</h3></div>

      </v-flex>

    </v-layout>
    <v-card style="border-radius: 3px; border: 1px solid lightgray;" class="elevation-0">

      <v-layout
        text-xs-left
        wrap
      >

        <v-flex md6 xs12 order-md2 order-xs2>

          <v-tabs-items v-model="tabs" style="border-radius: 3px; overflow: hidden">
            <v-tab-item
              v-for="(page, i) in box.pages"
              :key="'page-'+i"
            >

              <v-card-text style="height: 100%;">
                <v-layout align-space-around justify-space-around column fill-height>
                  <v-flex>
                    <div><h3 class="headline mb-3">{{page.title}}</h3></div>
                    <div class="body-1">{{ page.text }}</div>

                  </v-flex>
                  <v-flex style="max-height: 56px;">
                    <v-layout align-end>
                      <v-flex>
                        <v-btn class="ml-0 mr-0 mt-3 mb-0 "  outline style="" :to="page.link">Learn More</v-btn>
                      </v-flex>
                      <v-flex>
                        <div class="caption font-weight-light text-xs-right">Image credits: {{ page.credits }}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>

            </v-tab-item>
          </v-tabs-items>

        </v-flex>
        <v-flex md6 xs12 order-md1 order-xs1 class="grey darken-3">
          <v-img style="min-height: 100%;"
                 :src="require('@/assets/'+image)"
                 aspect-ratio="2.75"
          ></v-img>
        </v-flex>

      </v-layout>

    </v-card>

  </v-flex>

</template>

<script>
export default {
  props: {
    box: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      image: 'transparent.png',
      tabs: 0,
      expand: null
    }
  },
  mounted () {
    this.updateImage()
  },
  methods: {
    openFullPage () {
      this.$router.push(this.$router.currentRoute.path + '#details')
    },
    next () {
      const active = parseInt(this.tabs)
      this.tabs = (active < 2 ? active + 1 : 0)
    },
    updateImage () {
      if (this.box.pages[this.tabs]) {
        if (this.box.pages[this.tabs].image) {
          this.image = this.box.pages[this.tabs].image
        } else {
          this.image = 'transparent.png'
        }
      }
    }
  },
  watch: {
    'tabs': function () {
      this.expand = null
      this.updateImage()
    }
  }
}
</script>

<style>
  .v-expansion-panel__header {
    padding: 16px;
  }

  .v-tabs__item--active {
    color: red;
  }

  .v-window__container--is-active, .v-window__container, .v-window-item, .v-window {
    height: 100% !important;
  }
</style>
